"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createItemRefs = createItemRefs;
exports.getColumnDistribution = getColumnDistribution;
exports.getElementWidth = getElementWidth;
exports.getMenuColumns = getMenuColumns;
exports.getOverflowNavItemRefWidths = getOverflowNavItemRefWidths;
exports.getShouldOverflow = getShouldOverflow;
var _react = require("react");
// This function gets the width of a dom element, to be used on the overflow detector refs and navbar container
function getElementWidth(element) {
  if (element && element.offsetWidth) {
    return element.offsetWidth;
  } else {
    return 0;
  }
}

/////////////////////////////////////////////////////////////////////////////////////////////////////////
// This is a straightforward algorithm for determining whether the nav items should be overflowed      //
// We accumulate the width of each element together and check if its less then the available nav width //
// if the width of one item is greater than what is allowed (minus the chevron dropdown button)        //
// then that element and all further elements are added to the overflow                                //
/////////////////////////////////////////////////////////////////////////////////////////////////////////
function getShouldOverflow(items, itemWidths, navbarWidth, chevronWidth) {
  let currentWidth = 0;
  let addRemainingItemsToOverflow = false;
  const overflowed = [];
  const visible = [];
  items.forEach(item => {
    const itemWidth = itemWidths[item.key] || 0;
    const widthAfterAddingItem = itemWidth + currentWidth;
    const navbarWidthWithoutSubmenuCaret = navbarWidth - chevronWidth;
    const reachedOverflowCutoff = widthAfterAddingItem > navbarWidthWithoutSubmenuCaret;

    // If adding the item would be greater than the available navbar width
    if (reachedOverflowCutoff || addRemainingItemsToOverflow) {
      // Then add to overflow items
      overflowed.push(item);
      // We want to keep adding items to the menu, but we dont want small items
      // To be added, so once we get an overflow item we add all the rest to overflow
      addRemainingItemsToOverflow = true;
    } else {
      visible.push(item);
      currentWidth += itemWidth;
    }
  });
  return [visible, overflowed];
}
// Get the width of each overflow detector element
function getOverflowNavItemRefWidths(overflowItemRefs) {
  // We get a list of refs, and we accumulate the keys with their widths
  const overflowItemRefWidths = {};
  Object.keys(overflowItemRefs).forEach(itemKey => {
    // The element is basically the dom value of the nav menu item in the overflow detector
    const element = overflowItemRefs[itemKey].current;
    if (element) {
      overflowItemRefWidths[itemKey] = getElementWidth(element);
    }
  });
  return overflowItemRefWidths;
}

// These refs are used by the overflow detector to measure the elements width
function createItemRefs(mappedMenuData = []) {
  const newItemRefs = {};
  mappedMenuData.forEach(menuItem => {
    newItemRefs[menuItem.key] = /*#__PURE__*/(0, _react.createRef)();
  });
  return newItemRefs;
}

/*
  This algorithm determines the optimal column distribution for dropdowns
  It takes a number of items and returns an array with the number of items which should exist
  Ex. 13 items, 5 max items per column should produce --> [ 5, 4, 4 ]
  Ex. 12 items, 5 max items per column should produce --> [ 4, 4, 4 ]
  N.B. for E.G. 13 items, UX prefers [5,4,4] not [5,5,3]
  See the tetsts in NavBarHelper.test.js for the desired results for each number of items.
*/
function getColumnDistribution(numItems) {
  // This number can be parameterized. The algorithm will still work. But the UX calls for 5
  const maxItemsPerColumn = 5;
  // Find the number of columns that would be needed to evenly distribute items
  // E.g. 7 items, 5 per column would yield 2 columns
  const numCols = Math.ceil(numItems / maxItemsPerColumn);
  // Create an array with the number of columns
  // E.g. 7 items, 5 per column would yield [0,0]
  const columnData = Array(numCols).fill(0);
  // Create an array of length num items so that we can iterate over it
  const itemsArr = Array(numItems).fill(0);

  /*
    Basically this algorthm goes like this for e.g. 5 items and 3 max items per column:
    We have itemsArr which looks like [0,0,0,0,0,0]
    We have columnData [0,0]
    For each item in itemsArr we go from right to left adding to the columnData representation
    1) [1,0] 2) [1,1] 3) [2,1] ... until we get to [3,2]
    The result is what we wish our columns to look like (in this case 3 items in the first column, 2 in the second)
    Probably reduce is techically the correct pattern here, but this is more straightforward.
  */
  let index = 0;
  itemsArr.forEach(() => {
    columnData[index] = columnData[index] + 1;
    index++;
    if (index >= numCols) {
      index = 0;
    }
  });
  return columnData;
}

// This function 'hydrates' our column data structure with the actual data
function getMenuColumns(menuItems, colDistribution) {
  // Make each an array for each column
  const container = colDistribution.map(() => []);
  let index = 0;
  // Fill each column with the appropriate number of items
  // E.g. [
  //        [ { itemOne}, {itemTwo}, {itemThree}],
  //        [ { itemFour}, {itemFive} ]
  // ]
  colDistribution.forEach((col, colIndex) => {
    const colArr = new Array(col).fill(0);
    colArr.forEach(() => {
      container[colIndex].push(menuItems[index]);
      index++;
    });
  });
  return container;
}
//# sourceMappingURL=NavBarHelpers.js.map